// prettier-ignore
import { Placement } from 'react-bootstrap/types'

export enum InputTypes {
    INTEGER_RANGE = 'INTEGER_RANGE',
    INTEGER = 'INTEGER',
    TEXT = 'TEXT',
    TEXTAREA = 'TEXTAREA',
    NUMBER = 'NUMBER',
    SELECT = 'SELECT',
    DOUBLE = 'DOUBLE',
    CHECKBOX = 'CHECKBOX',
    CHECKBOX_DISABLED = 'CHECKBOX_DISABLED',
    DATE_TIME_PICKER = 'DATE_TIME_PICKER',
    PASSWORD = 'PASSWORD',
    MULTI_SELECT = 'MULTI_SELECT',
    CREATABLE_MULTI_SELECT = 'CREATABLE_MULTI_SELECT',
    INPUT_WITH_SUGGESTIONS_DROPDOWN = 'INPUT_WITH_SUGGESTIONS_DROPDOWN',
}

export interface IErrMsg {
  message?: string
  values?: { [key: string]: string }
}

export interface IStringInputControl {
  name: string
  ref?: any
  changeWarning?: any
  isDisabled?: boolean
  placeholder?: string
  tooltipText?: string
  isColumn?: boolean
  isLabelHidden?: boolean
  label?: string
  precision?: string | number
  validationType?: string
  className?: string
  errMsg?: IErrMsg | undefined | any
  validationSchema?: any
  inputType?: string
  isRequired?: boolean
  isEmail?: boolean
  isFeedbackFixed?: boolean
  onEnter?: Function
  onBlur?: Function
  onChange?: Function
}

export interface ISelectInputControl {
  name: string
  options: string[]
  isDisabled?: boolean
  state?: any
  setState?: any
  convert?: any
  tooltipText?: string | JSX.Element
  selected?: string
  label?: string
  className?: string
  isColumn?: boolean
  isLabelHidden?: boolean
  tooltipPosition?: Placement
  disabledOptions?: string[]
  changeWarning?: string
  onChange?: Function
}

export interface IInputWithSuggestionsDropdownControl extends IStringInputControl {
  options: string[]
}

export interface IDateTimePicker {
  name: string
  state: any
  valueKey: string
  messageKey: string
  schema?: any
  disabled?: boolean
  className?: string
  showTimeSelect?: boolean
  showTimeSelectOnly?: boolean
  timeIntervals?: number
  minDate?: Date
  maxDate?: Date
  timeSchema?: string
  timeFormat: string
  description?: string
  isColumn?: boolean
  isRequired?: boolean
  isLabelHidden?: boolean
  errMsg?: IErrMsg
  touched?: any
  setTouched?: (value: any) => void
  isParentDisabled?: boolean
  onEnter?: Function
  onBlur?: Function

  setState(newState: any): void
}

export interface ISearchInput {
  state: any
  name: string
  placeholder?: string
  label?: string
  className?: string

  setState(state: any): void
}
